import * as React from 'react';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import ptBR from 'date-fns/locale/pt-BR';

export default function DatePicker(props) {

    const { views = ['year', 'month', 'day'], label, minDate = new Date(1900, 1, 1), maxDate = new Date(2099, 12, 31), format = null, value, handleChange, disabled = false } = props;

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
            <MobileDatePicker
                views={views}
                label={label}
                disabled={disabled}
                minDate={minDate}
                maxDate={maxDate}
                value={value}
                onChange={handleChange}
                inputFormat={format}
                renderInput={(params) => <TextField {...params} style={{ width: '100%' }} />}
            />
        </LocalizationProvider>
    )
}
